import React, {Component} from 'react';

import icon from './icona_rimedi.png'
import Cookies from 'universal-cookie';

class GetApp extends Component {


    constructor(props) {
        super(props);
        this.state = {isLoading: true};

        this.enabled = true;
        this.cookieName = "SmartBannerStatus";
        this.android = "https://play.google.com/store/apps/details?id=com.kaleidosstudio.natural_remedies";
        this.ios = "https://itunes.apple.com/us/app/the-natural-remedies/id1081776412";
        this.else = "http://naturalremedies.kaleidosapp.com/";

        this.AppName = {};
        this.AppName['en'] = "Natural Remedies";
        this.AppName['it'] = "Rimedi Naturali";

        this.ButtonGet = {};
        this.ButtonGet['en'] = "Go";
        this.ButtonGet['it'] = "Vai";

        this.AppInfo = {};
        this.AppInfo['en'] = "Free on - ";
        this.AppInfo['it'] = "Gratis su - ";

        this.GoTo = this.GoTo.bind(this);
        this.Close = this.Close.bind(this);

    }

    componentDidMount() {

        const cookies = new Cookies();

        if (cookies.get(this.cookieName) !== undefined) {
            return;
        }


        this.language = global.api.ValidateLanguage(this.props.main.language);

        this.device = 'else';


        if (/Android/i.test(navigator.userAgent)) {
            this.device = 'android';
        }

        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            this.device = 'ios';
        }

        if (this.device === "else") {
            this.link = this.else;
            this.market = "App Store"
        }

        if (this.device === "ios") {
            this.link = this.ios;
            this.market = "iTunes"
        }

        if (this.device === "android") {
            this.link = this.android;
            this.market = "Google Play"
        }


        this.setState((prevState, props) => {
            return {isLoading: false};
        });
    }

    GoTo() {
        window.open(this.link, "_blank");
        this.Close();
    }

    Close() {
        const cookies = new Cookies();

        cookies.set(this.cookieName, true, {'maxAge': 432000});

        this.setState((prevState, props) => {
            return {isLoading: true};
        });

    }

    render() {

        if (this.state.isLoading === true) {
            return null;
        }

        return (
            <div style={{width: '100%'}}>
                <div className="TopGetAppPosition"/>

                <div className="TopGetAppPosition TopGetApp BodyText"
                     style={{color: 'white', fontSize: '16px', position: 'fixed', top: 0}}>
                    <div
                        onClick={(e) => {
                            this.Close();
                        }}
                        className={"fa fa-window-close"} style={{
                        paddingLeft: '10px',
                        fontSize: '15px',
                        color: 'rgba(220,220,220,0.7)',
                        paddingRight: '15px',
                        cursor:'pointer'
                    }}/>


                    <div
                        onClick={(e) => {
                            this.GoTo();
                        }}
                    >
                        <img style={{ cursor:'pointer',width: '45px', height: '45px', marginRight: '10px'}} src={icon} alt={"logo"}/>
                    </div>
                    <div
                        onClick={(e) => {
                            this.GoTo();
                        }}
                        style={{display: 'flex', cursor:'pointer', flexDirection: 'column'}}>
                        <div>{this.AppName[this.language]}</div>
                        <div style={{fontSize: '12px', color: 'rgba(200,200,200,0.8)', marginTop: '5px'}}>
                            {this.AppInfo[this.language]}{this.market}
                        </div>
                    </div>
                    <div style={{flexShrink: 1, flexBasis: '20px'}}/>
                    <div
                        onClick={(e) => {
                            this.GoTo();
                        }}
                        style={{
                            position: 'absolute',
                            right: '10px',
                            padding: '10px',
                            minWidth: '50px',
                            cursor: 'pointer',
                            backgroundColor: 'red',
                            textAlign: 'center',
                        }}> {this.ButtonGet[this.language]}
                    </div>
                </div>
            </div>
        );

    }
}

export default GetApp;





// WEBPACK FOOTER //
// ./src/include/GetApp.js